import axios from 'axios'

export const DashboardService = {
  calculation
}

function calculation () {
  return axios.get(`dashboard/calculation`).then()
}
